<script setup>
import { RouterView } from 'vue-router'
import CommonNav from './components/CommonNav.vue'
import HeaderBG from './components/HeaderBG.vue'

import HomeHeaderBG from './components/Home/HomeHaederBG.vue'
import tool1 from '/src/image/home/tool1.png'
import tool2 from '/src/image/home/tool2.png'
import tool3 from '/src/image/home/tool3.png'
import QRCode from '/src/image/common/QRCode.jpg'
import footer1 from '/src/image/common/footer1.png'
import phoneIcon from '/src/image/common/phoneIcon.png'
import gongAn from '/src/image/common/gongAn.png'
import footer2 from '/src/image/common/footer2.jpg'

const openChat = () => {
  _MICHAT.mini.startChat()
}

</script>

<template>
  <CommonNav>
  </CommonNav>
  <HeaderBG>
    <HomeHeaderBG></HomeHeaderBG>
  </HeaderBG>
  <div class="tool_list">
    <div class="tool_item">
      <el-popover placement="left" width="auto" trigger="hover" :popper-style="{
        background: '#5236FF',
        border: 'none',
        padding: '5px'
      }">
        <template #reference>
          <el-image :src="tool1" />
        </template>
        <div class="phone_text">
          客服电话：0755-23760429
        </div>
      </el-popover>
    </div>
    <div class="tool_item" @click="openChat">
      <el-image :src="tool2" />
    </div>
    <div class="tool_item">
      <el-popover placement="left" width="auto" trigger="hover" :popper-style="{
        background: '#5236FF',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        minWidth: 'unset',
        padding: '6px'
      }">
        <template #reference>
          <el-image :src="tool3" />
        </template>
        <div class="QRCode">
          <el-image :src="QRCode" />
        </div>
      </el-popover>
    </div>
  </div>
  <div class="content">
    <RouterView />
  </div>

  <footer>
    <div class="footer_top">
      <div class="left">
        <div class="title__wrapper">
          <div class="icon_wrapper">
            <img :src="footer1" alt="">
          </div>
          一对一贵宾服务
        </div>
        <!--        <div class="left_text">-->
        <!--          <div>2728 Hickory StreetSalt</div>-->
        <!--          <div>Lake City, UT 84104</div>-->
        <!--        </div>-->
      </div>
      <div class="middle">
        <div class="title">联系方式</div>
        <div class="list">
          <div class="item">售前商务：0755-23760429</div>
          <div class="item">售后客服：0755-23762706</div>
          <div class="item">地址：深圳市宝安区石岩街道塘头社区塘头1号路8号创维创新谷2#楼A1016</div>
          <div class="item">邮箱：kefu@shanxianyun.com</div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <el-image class="icon" :src="phoneIcon" />
          <div class="text">0755-23760429</div>
        </div>
        <img class="QRCode" :src="footer2" alt="QRCode">
      </div>
    </div>
    <div class="footer_bottom">版权所有：深圳闪显信息技术有限公司©2023-2025 &nbsp;&nbsp;&nbsp;&nbsp; 增值电信业务经营许可证：B2-20253081</div>
    <div class="footer_bottom"><a href="https://beian.miit.gov.cn" style="color: rgb(116, 154, 227) !important;" target="_blank">粤ICP备2024215886号</a>&nbsp;&nbsp;&nbsp;&nbsp;
      <el-image style="width: 15px; height: 15px" :src="gongAn" />&nbsp;<a style="color: rgb(116, 154, 227) !important;" href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002009040" rel="noreferrer" target="_blank">粤公网安备44030002009040号</a>
    </div>
  </footer>
</template>

<style>
body {
  max-height: 100vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

.el-popper[data-popper-placement^=left] .el-popper__arrow:before {
  background-color: #5236FF !important;
  border: none !important;
}

/* 为所有的滚动条设置样式 */
::-webkit-scrollbar {
  width: 8px;
  /* 设置滚动条的宽度 */
  height: 8px;
  /* 滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
  /* 设置滚动条轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #b6b6b6;
  border-radius: 4px;
  /* 设置滚动条滑块的背景颜色 */
}

/* 当鼠标滑过滑块 */
::-webkit-scrollbar-thumb:hover {
  background: #969696;
  /* 设置滚动条滑块的鼠标悬停背景颜色 */
}
</style>

<style lang="scss" scoped>
.content {
  width: calc(100% - 8px);
}

.phone_text {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background-color: inherit;
  color: #fff;
}

.QRCode {
  width: 80px;
  height: 80px;
  border-radius: 6px;
}

.tool_list {
  position: fixed;
  right: 12px;
  bottom: 30%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  // gap: 4px;

  .tool_item {
    width: 50px;
    height: 50px;
    cursor: pointer;
    position: relative;
    margin-top: 4px;
    &:first-child {
      margin-top: 0;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

footer {
  height: 400px;
  display: flex;
  flex-direction: column;
  font-family: 'Times New Roman', Times, serif;

  .footer_top {
    flex: 1;
    padding: 80px 15% 0 15%;
    background: #eaefff;
    display: flex;
    justify-content: space-between;

    .left,
    .middle,
    .right {
      font-weight: 700px;

      .title {
        line-height: 40px;
        margin-bottom: 20px;
        font-size: 22px;
        font-weight: 700;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 600;

      .title__wrapper {
        display: flex;
        align-items: center;
        font-size: 22px;
        margin-bottom: 20px;

        .icon_wrapper {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
          background: #3A0CA3;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }
        }
      }

      .left_text {
        font-family: PingFang SC;
        font-size: 12px;
        line-height: 16.8px;
        text-align: left;
      }
    }

    .middle {
      font-weight: 700;
      max-width: 225px;

      .title {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 22.4px;
        text-align: left;

      }

      .list {
        font-size: 16px;
        font-weight: 500;
        display: flex;
        flex-direction: column;
        // gap: 14px;
        align-items: flex-start;

        .item {
          font-family: PingFang SC;
          font-size: 12px;
          font-weight: 400;
          line-height: 16.8px;
          text-align: left;
          color: #000000;
          margin-top: 14px;
          &:first-child {
            margin-top: 0;
          }
        }
      }
    }

    .right {
      font-size: 22px;
      font-family: sans-serif;

      .title {
        display: flex;
        // gap: 8px;

        .icon {
          width: 24px;
          height: 24px;
        }

        .text {
          font-family: PingFang SC;
          font-size: 16px;
          font-weight: 400;
          line-height: 22.4px;
          text-align: left;
          margin-left: 8px;
        }
      }

      .QRCode {
        margin-left: 32px;
        width: 91px;
        height: 91px;
      }
    }
  }

  .footer_bottom {
    padding: 5px 0 0 0;
    height: 15px;
    background: #36414d;

    font-size: 10px;
    text-align: center;
    color: #fff;
  }
}
</style>
